// extracted by mini-css-extract-plugin
module.exports = {"SuccessIcon":"ResetPasswordSuccessMessage_SuccessIcon__30f-G","ActionButton":"ResetPasswordSuccessMessage_ActionButton__1Ytsd"};